// Select value for a retainer without a user, which all users in the firm can use
export const ALL_USERS_OPTION = 'allUsers';
export const ALL_USERS_LABEL = 'All Users';

// Shown wherever retainers can be changed, to everyone but Lexo Admins
export const RETAINER_CHANGE_NOTE =
    'Changing a retainer document may impact live deals. Please contact info@lexo.ai for support in making a change to ensure no client impact.';
